import React, {Component} from 'react';
import './list.css';
import Constant from "./constant.js"
import {changZykDocumentCount, getAnalyze, getZykDocumentList} from '../../actions'
import {List, Pagination, Spin} from "antd";
import {connect} from "react-redux";
import $ from "jquery";
import {applicationName, converFileSize} from '../../utils'
import {HEADER_HEIGHT} from "../../constants";

class FileList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            count: 0,
            size: Constant.configPagesize,
            start: 1,
            loading: false,
            height:  applicationName()==='pms'?window.innerHeight - HEADER_HEIGHT - 172: window.innerHeight - HEADER_HEIGHT - 272,
        }
    }


    // 在组件即将被挂载到页面的时刻执行
    componentWillMount() {
        this.setState({
            loading: true,
        })
        let onlyMe = 1;
        if (this.props.onlyMe) {
            onlyMe = 0
        }
        let param = {
            "query": this.props.searchText,
            "isAll": onlyMe,
            "start": this.state.start,
            "size": this.state.size
        };
        getZykDocumentList(param, this.updateFileList.bind(this));
    }

    setFileCount() {
        this.props.changeCount(this.state.count);
    }

    /**
     * 更新列表数据的展示
     * @param result
     */
    updateFileList(result) {
        this.props.changZykDocumentCount(result.count)

        //处理前台的分页数据
        let resultData = result.data;

        this.setState({
            data: resultData,
            loading: false,
            count: result.count
        })


    }

    /**
     * 分词在页面高亮显示；
     * @param data
     */
    lightAnayWorldInList(data){
        console.log('lightAnayWorldInList start');
        //按照优先级排序
        let listData = data.sort(function (a, b) {
            return b.length - a.length
        });
        //定义正则表达式对象  array[i]是关键字   "g"是指全局范围
        let a = new RegExp(listData.join("|"), "g");
        $(".content-header").each(function () {
            var html = $(this)[0].getAttribute('title')
            html = html.replace(a, function (item) {
                return "<span style='color:#F00'>" + item + "</span>"
            });
            $(this).html(html);
        });
        console.log('lightAnayWorldInList  end');
    }


    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.tableKey === 5) {
            this.setState({
                loading: true,
                start: 1,
            })

            let onlyMe = 1;
            if (nextProps.onlyMe) {
                onlyMe = 0
            }
            let param = {
                "query": nextProps.searchText,
                "isAll": onlyMe,
                "start": 1,
                "size": this.state.size
            };
            //请求后台获取稿件列表数据
            getZykDocumentList(param, this.updateFileList.bind(this));
        }
    }

    getZykFilePageList(page, pageSize) {
        this.setState({
            loading: true,
        })

        let onlyMe = 1;
        if (this.props.onlyMe) {
            onlyMe = 0
        }

        this.setState({
            start: page
        })

        let param = {
            "query": this.props.searchText,
            "isAll": onlyMe,
            "start": page,
            "size": pageSize,
        };
        //请求后台获取稿件列表数据
        getZykDocumentList(param, this.updateFileList.bind(this));
    }


    //插入附件文件
    insertDocument(data) {

        //加入加载条
        var index;
        if (applicationName() === 'contribute') {

            index=window.frames[0].layer.load();
            window.frames[0].insertFileinfo(data);
            window.frames[0].layer.close(index);
        } else {
            index=window.parent.layer.load();
            window.parent.insertFileinfo(data);
            window.parent.layer.close(index);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.tableKey === 5) {
            console.info("file_list");
            //分词处理，分词高亮显示；
            if (this.props.searchText) {
                let param = {
                    str: this.props.searchText
                }
                //请求后台获取分词数据
                getAnalyze(param, this.lightAnayWorldInList.bind(this));
            }else {
                $(".content-header").each(function () {
                    if ($(this).find('span')[0] && $(this).find('span')[0].style) {
                        $(this).find('span')[0].style.color = '#000';
                    }
                });
            }
        }
    }


    addHoverRemark() {
        $(".fileList").on('mouseenter', '.file-box', function () {
            $(this).find(".image-remake").animate({bottom: "0px"}, 300);
        })

        $(".fileList").on('mouseleave', '.file-box', function () {
            $(this).find(".image-remake").animate({bottom: "-35px"}, 300);
        });
    }

    componentDidMount() {
        this.addHoverRemark()
    }


    render() {
        return (

            <Spin spinning={this.state.loading}>
                <div className='fileList' style={{height:this.state.height+'px',overflow: "auto"}}>
                    <List
                        itemLayout="vertical"
                        size="large"
                        dataSource={this.state.data}
                        renderItem={item => (
                            <List.Item>
                                <List.Item.Meta
                                    // avatar={<Avatar src={item.avatar} />}
                                    title={<div className="item-box">
                                        <div className="file-box" onClick={() => {
                                            this.insertDocument(item)
                                        }}>
                                            <img src={Constant.fileIcon(item.ZykOtherFile_ext)}/>
                                            <div className="image-remake">
                                                插入附件
                                            </div>
                                        </div>
                                        <div className={"content-box  content-box-" + applicationName()}>
                                            <p className="content-header file-name"
                                               title={item.ZykOtherFile_name}>{item.ZykOtherFile_name}</p>
                                        <p><a href={item.ZykOtherFile_path+'?download=1'}>下载 </a>{converFileSize(item.ZykOtherFile_size)}</p>
                                            <p className="content-bottom">
                                                <span>来源:{Constant.getDataSource(item.ZykOtherFile_dataSource)}</span>
                                                <span title={item.ZykOtherFile_createDate}>日期:{item.ZykOtherFile_createDate}</span>
                                            </p>
                                        </div>
                                    </div>}
                                />
                            </List.Item>
                        )}
                    />
                </div>
                <div className='pageTables'>
                <Pagination  showLessItems={true} current={this.state.start} total={this.state.count} defaultPageSize={this.state.size}
                            defaultCurrent={1}
                            onChange={(page, pageSize) => {
                                this.getZykFilePageList(page, pageSize)
                            }} onShowSizeChange={(page, pageSize) => {
                    this.getZykFilePageList(page, pageSize)
                }}/>
                </div>
            </Spin>

        );
    }
}

function mapStateToProps(state) {
    return {
        searchText: state.zykReducer.searchText,
        onlyMe: state.zykReducer.onlyMe,
        tableKey: state.zykReducer.tableKey,
        doSearch: state.zykReducer.doSearch
    }
}

function mapStateToMethod(dispatch) {
    return {
        changZykDocumentCount: function (zykStoryCount) {
            return dispatch(changZykDocumentCount(zykStoryCount));
        }
    }
}

export default connect(mapStateToProps, mapStateToMethod)(FileList);


